// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"InfoIcon_infoIcon__h_3Il"};